import { Directive, EventEmitter, Host, HostListener, Input, Output } from '@angular/core';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { Sort } from '@angular/material/sort';

@Directive({
  selector: '[appAnnounceSortChange]'
})
export class AnnounceSortChangeDirective {

  constructor(
    private _liveAnnouncer: LiveAnnouncer,
  ) { }

  @HostListener('matSortChange', ['$event']) announceSortChange(sortState: Sort) {
		if(sortState.direction) {
			this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
		} else {
			this._liveAnnouncer.announce('Sorting cleared');
		}
	}

}
